import { useMutation } from 'react-query'
import { api } from '../../../api'

const updateHasBecomeProject = async (id: number) => {
  const response = await api.patch(`/requests/${id}/has-become-project`)
  return response.data
}

export const useRequestUpdateHasBecomeProjectMutation = () => {
  return useMutation({
    async mutationFn (id: number) {
      const response = await updateHasBecomeProject(id)
      return response.data
    }
  })
}
